import React, { useId } from "react";
import PropTypes from "prop-types";

const path =
  "M22.25 12.0576C22.25 14.2479 22.2499 15.9683 22.0693 17.3115C21.8842 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8842 17.3115 22.0693C15.9683 22.2499 14.2479 22.25 12.0576 22.25L11.9424 22.25C9.75212 22.25 8.03174 22.2499 6.68848 22.0693C5.31182 21.8842 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.75012 15.9683 1.74999 14.2479 1.75 12.0576L1.75 11.9424C1.74999 9.75212 1.75012 8.03174 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.03174 1.75012 9.75212 1.74999 11.9424 1.75L12.0576 1.75C14.2479 1.74999 15.9683 1.75012 17.3115 1.93066C18.6882 2.11575 19.7805 2.50313 20.6387 3.36133C21.4969 4.21953 21.8842 5.31182 22.0693 6.68848C22.2499 8.03174 22.25 9.75213 22.25 11.9424L22.25 12.0576ZM18 8.5C18 7.94772 17.5523 7.5 17 7.5L10.792 7.5C10.4062 6.61705 9.52516 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11C9.52516 11 10.4062 10.383 10.792 9.5L17 9.5C17.5523 9.5 18 9.05228 18 8.5ZM18 15.5C18 14.1193 16.8807 13 15.5 13C14.4748 13 13.5938 13.617 13.208 14.5L7 14.5C6.44771 14.5 6 14.9477 6 15.5C6 16.0523 6.44771 16.5 7 16.5L13.208 16.5C13.5938 17.383 14.4748 18 15.5 18C16.8807 18 18 16.8807 18 15.5Z";

const Settings2Icon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const gradientId = `settings2-gradient-${id}`;

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={isActive ? undefined : "0.5"}>
        <path d={path} fill={`url(#${gradientId})`} />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="18.0402"
          y1="20.8308"
          x2="1.79217"
          y2="5.05788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D946EF" />
          <stop offset="1" stopColor="#67E8F9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

Settings2Icon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Settings2Icon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default Settings2Icon;
